module.exports = __webpack_public_path__ + "static/media/asana-icon.96f7b348.png";